// :cow: Cosmose CONFIDENTIAL :iso:
import { Pipe, PipeTransform } from '@angular/core';
import { SpyLineChartDataSet } from '@coa/app/shared/spy-line-chart/model/spy-line-chart-data-set';
import { Series } from '@coa/app/shared/stores-shared/models/series';
import { DateFormatService } from '@coa/app/shared/chart-data-series/services/date-format.service';
import { GroupTypes } from '@coa/app/shared/filters/select-group-types/models/group-types';

@Pipe({
  name: 'chartDataMultiSeries',
})
export class ChartDataMultiSeriesPipe implements PipeTransform {

  constructor(
    private dateFormatService: DateFormatService,
  ) {
  }

  transform(series: Series[][], labels: string[]): SpyLineChartDataSet[] {
    if (!series) {
      return [];
    }

    return series.map((seriesData, index) => {
      return {
        color: (labels[index] === GroupTypes.COMPETITORS) ? '#9C60FF' : '#00A2FF',
        name: labels[index],
        series: seriesData.map(element => ({value: element.value, label: this.dateFormatService.formatLabel(element.key)})),
      };
    });
  }
}
